module.exports = __webpack_public_path__ + "img/shield.99c6fab0.png";